import { t } from '../i18n';

const validateEmail = (email: string): string => {
    if (!email) {
        return '';
    }

    const [user, domain] = email.split('@');
    if (!user || !domain) {
        return t('email');
    }

    const isValidDomain = domain.split('.').filter(Boolean).length > 1;
    if (!isValidDomain) {
        return t('email');
    }

    return '';
};

export default validateEmail;
